import {
  TSetFilterData,
  TSuccessTextBoxFilterData,
  TClearFilterData,
  TClearCurrentTextBoxValues,
  TSetCurrentTextBoxIsLoading,
  TSetFilterItems,
  TSetSortItemsData,
  TSetCurrentSortItem
} from '../../../../../commonTypes/filters';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFiltersState } from '../../../../../features/Filters/redux/types';
import { FilterComponentTypes } from '../../../../../features/Filters/const';

export const initialState: Partial<TFiltersState> = {
  modal: {
    filterItems: [],
    sortItems: [],
    currentSortItem: null,
    currentFilterItems: [],
    currentTextBoxItems: [],
    currentTextBoxIsLoadingStates: []
  }
};

const reducerSlice = createSlice({
  name: 'modalFilters',
  initialState,
  reducers: {
    setFilterItems: (state, { payload }: PayloadAction<TSetFilterItems>): void => {
      const { filterItems, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal:
          state.modal.filterItems = filterItems;
          break;

        default:
          break;
      }
    },

    setSortItemsData: (state, { payload }: PayloadAction<TSetSortItemsData>): void => {
      const { sortItems, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal:
          state.modal.sortItems = sortItems;
          break;

        default:
          break;
      }
    },

    setCurrentSortItem: (state, { payload }: PayloadAction<TSetCurrentSortItem>): void => {
      const { newSortItem, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal:
          state.modal.currentSortItem = newSortItem;
          break;

        default:
          break;
      }
    },

    setFilter: (state, { payload }: PayloadAction<TSetFilterData>): void => {
      const { newFilterItem, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal: {
          const newFilterItems = state.modal.currentFilterItems.filter(
            (item) => item.internalName !== newFilterItem.internalName
          );
          state.modal.currentFilterItems = [...newFilterItems, newFilterItem];
          break;
        }

        default:
          break;
      }
    },

    clearFilter: (state, { payload }: PayloadAction<TClearFilterData>): void => {
      const { filterInternalName, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal: {
          const newFilterItems = state.modal.currentFilterItems.filter(
            (item) => item.internalName !== filterInternalName
          );
          state.modal.currentFilterItems = [...newFilterItems];
          break;
        }

        default:
          break;
      }
    },

    clearCurrentFilters: (state, { payload }: PayloadAction<FilterComponentTypes>): void => {
      switch (payload) {
        case FilterComponentTypes.Modal:
          state.modal.currentFilterItems = [];
          break;

        default:
          break;
      }
    },

    clearCurrentTextBoxValues: (state, { payload }: PayloadAction<TClearCurrentTextBoxValues>): void => {
      const { textBoxItems, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal: {
          const values = state.modal.currentTextBoxItems.filter(
            (textBox) => !textBoxItems.includes(textBox.internalName)
          );
          state.modal.currentTextBoxItems = [...values];
          break;
        }

        default:
          break;
      }
    },

    setCurrentTextBoxIsLoading: (state, { payload }: PayloadAction<TSetCurrentTextBoxIsLoading>): void => {
      const { internalName, isLoading, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal: {
          const values = state.modal.currentTextBoxIsLoadingStates.filter(
            ({ internalName }) => internalName !== internalName
          );
          state.modal.currentTextBoxIsLoadingStates = [...values, { internalName, isLoading }];
          break;
        }

        default:
          break;
      }
    },

    resetFilters: (state, { payload }: PayloadAction<FilterComponentTypes>): void => {
      switch (payload) {
        case FilterComponentTypes.Modal: {
          state.modal.filterItems = [];
          state.modal.sortItems = [];
          state.modal.currentSortItem = null;
          state.modal.currentFilterItems = [];
          state.modal.currentTextBoxItems = [];
          state.modal.currentTextBoxIsLoadingStates = [];
          break;
        }

        default:
          break;
      }
    },

    onFetchSuccessTextBoxFilterData: (state, { payload }: PayloadAction<TSuccessTextBoxFilterData>): void => {
      const { currentTextBox, type } = payload;

      switch (type) {
        case FilterComponentTypes.Modal: {
          const values = state.modal.currentTextBoxItems.filter(
            (textBox) => textBox.internalName !== currentTextBox.internalName
          );
          state.modal.currentTextBoxItems = [...values, currentTextBox];
          break;
        }

        default:
          break;
      }
    }
  }
});

export const {
  setFilterItems,
  setSortItemsData,
  setCurrentSortItem,
  clearCurrentFilters,
  setFilter,
  clearFilter,
  clearCurrentTextBoxValues,
  setCurrentTextBoxIsLoading,
  resetFilters,
  onFetchSuccessTextBoxFilterData
} = reducerSlice.actions;

export default reducerSlice.reducer;
